import { Button }              from '@/components/ui/button';
import { DialogBody }          from '@/components/ui/dialog';
import { DialogContent }       from '@/components/ui/dialog';
import { DialogFooter }        from '@/components/ui/dialog';
import { DialogHeader }        from '@/components/ui/dialog';
import { DialogRoot }          from '@/components/ui/dialog';
import { DialogTitle }         from '@/components/ui/dialog';
import { useTranslation }      from 'react-i18next';

interface IDeleteModalProps {
	modalIsOpen: boolean;
	onCancel: () => void;
	onConfirm: () => Promise<void>;
	deleteMessage: string;
}

const DeleteModal = (props: IDeleteModalProps) => {
	const { modalIsOpen, onCancel, onConfirm, deleteMessage } = props;
	const { t } = useTranslation();

	return (
		<DialogRoot role="alertdialog" open={modalIsOpen}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>{t('app.actions.confirmDeletionTitle')}</DialogTitle>
				</DialogHeader>
				<DialogBody>
					<p>
						{deleteMessage}
					</p>
				</DialogBody>
				<DialogFooter>
					<Button 
						onClick={() => {
							onCancel();
						}} 
						variant="outline"
					>
						{t('app.actions.cancel')}
					</Button>
					<Button 
						bg="red" 
						height="40px" 
						color="white" 
						_hover={{ bg: 'red.500' }} 
						onClick={async() => {
							await onConfirm();
						}}
					>
						{t('app.actions.delete')}
					</Button>
				</DialogFooter>
			</DialogContent>
		</DialogRoot>
	)
}

export default DeleteModal